<template>
  <section class="section mobile_div section_bg custom_page_v2">
    <div>

      <div class="section_header mobile_div back_div_element" v-if="is_load"  >
        <router-link tag="a" class="btn" :to="{name: 'portfolio'}"  ><i class="fa fa-backward"></i> Назад</router-link>

      </div>
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="" v-if="is_load">
        <div class="section_header mobile_div nocenter">
          <h2 class="text-center">Редактировать работу</h2>
          <div class="container-fluid">
            <div class="form-group">
              <label for="exampleCategoryitem">Категория </label>
              <select id="exampleCategoryitem" v-model="work.category_id" required
                  class="form-control">

                <option  v-for="category in categorys" :value="category.last_id"
                    :key="category.last_id">{{
                    category.name
                  }}
                </option>



              </select>


            </div>
            <div class="form-group" >
              <label for="exampleDateStart">Дата начала </label>
              <input type="date" id="exampleDateStart" class="form-control" v-model="work.date_start"
                  required/>
            </div>
            <div class="form-group">
              <label for="exampleDateEnd">Дата завершения </label>
              <input type="date" id="exampleDateEnd" class="form-control" v-model="work.date_end"
                  required/>
            </div>
            <editorjsinput :onlyimage="true" :blocks_json="work.json.blocks" ref="editorjs" @save="onSaveEditor"></editorjsinput>


            <div class="alert alert-danger" v-if="iserror==true">
              <p>{{ error_message }}</p>
            </div>
            <base-button  @click="onSaveWork" >Сохранить работу</base-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import Editorjsinput from "../../models/Editorjsinput";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "EditPortfolio",
  data() {

    var app = this;

    return {
      'work_id':null,
      'work':null,
      'is_load':false,
      'categorys':[],
      'iserror':false,
      'error_message':'',




    }
  },
  mounted: function () {
    var app = this;

    let id = app.$route.params.id;
    Api.loadUserPortfolioWork(id,function(data){

      app.is_load=true;
      app.work=data.work;
      app.categorys=data.categorys;
    })

  },components: {
    'editorjsinput': Editorjsinput,LoadingBlock
  },methods:{

    onSaveWork(){
      var app=this;
      app.is_load=false;
      app.$refs.editorjs.save(function(editor_js_data){

        var newWork={};
        newWork['last_id']=app.work.last_id;
        newWork["date_start"]=app.work.date_start;
        newWork['date_end']=app.work.date_end;
        newWork['category']=app.work.category_id;
        newWork['json']=editor_js_data;
        Api.addWork(newWork, function () {
          app.is_load=true;
          app.iserror = false;
          app.data = [];

          app.$router.push({name: 'portfolio'});


        }, function (message) {
          app.is_load=true;
          app.iserror = true;
          app.error_message = message;
        })

      });
    },

    onSaveEditor(editor_js_data) {

      // Выполняем необходимые действия с `someData`
    }
  },
}
</script>

<style scoped>

</style>